/* src/app/global/components/global-settings-changecolortheme/global-settings-changecolortheme.component.scss */
/*# sourceMappingURL=global-settings-changecolortheme.component.css.map */
